import React from "react"
import { Box, Container, Text, Link, Flex } from "theme-ui"
import { InboundLink } from "../link"
import { getPagePath } from "../../utils/path"
import { LanguageSwitcherContext } from "../../context/languageSwitcherContext"

const CardCollection = ({ block }) => {
  console.log(block)
  const { cards } = block

  return (
    <Container sx={{ px: [0, 3, 3, 4], py: 0, mt: [5, 5, 5], mb: [5, 5, 7] }}>
      <Flex
        sx={{
          flexDirection: ["column", "column", "column", "row"],
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        {cards.map((card, index) => (
          <Card key={index} card={card} />
        ))}
      </Flex>
    </Container>
  )
}

const Card = ({ card }) => {
  const locale = React.useContext(LanguageSwitcherContext).activeLocale

  const { acronym, title, body, link } = card

  return (
    <Flex
      sx={{
        width: ["90%", "90%", "90%", "33%"],
        mx: "auto",
        p: [5, 5, 5],
        color: "dark",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: "80px",
        border: "1px solid",
        borderColor: "primary",
        alignItems: "stretch",
        alignContent: "stretch",
      }}
    >
      <Box sx={{}}>
        <Text as="p" sx={{ color: "primary", textTransform: "uppercase" }}>
          {acronym}
        </Text>
        <Text
          as="p"
          sx={{
            fontSize: "16px",
            textTransform: "uppercase",
            fontWeight: 500,
            height: "15%",
          }}
        >
          {title}
        </Text>
        <Text
          sx={{
            a: {
              color: "primary",
              textDecoration: "none",
              ":hover": {
                textDecoration: "underline",
              },
            },
          }}
          as="p"
          dangerouslySetInnerHTML={{ __html: body }}
        />
      </Box>
      <Box
        sx={{
          my: [3, 3, 0, 0],
          textAlign: "center",
          a: {
            fontFamily: "mono",
            textAlign: "center",
            color: "white",
            my: [5, 5, 3],
            whiteSpace: "nowrap",
            textDecoration: "none",
            backgroundColor: "primary",
            width: "fit-content",
            maxWidth: ["100%", "100%", "fit-content"],
            minWidth: ["100%", "100%", "fit-content"],
            borderRadius: "40px",
            border: "1px solid",
            borderColor: "primary",
            p: 2,
            px: 3,
            textTransform: "uppercase",
            fontSize: "15px",
            fontWeight: 400,
            ":hover": {
              backgroundColor: "secondary",
            },
          },
        }}
      >
        <InboundLink to={getPagePath(link.link, locale)}>
          {link.anchor}
        </InboundLink>
      </Box>
    </Flex>
  )
}

export default CardCollection
